import { render, staticRenderFns } from "./cModalFarmacia.vue?vue&type=template&id=d2de087a"
import script from "./cModalFarmacia.vue?vue&type=script&lang=js"
export * from "./cModalFarmacia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports